
  import { Component, Prop, Vue } from 'vue-property-decorator'
  
  @Component
  export default class IconDropdown extends Vue {
    @Prop({ default: '' }) id!: string;
    @Prop({ default: 'fa-solid fa-ellipsis-v' }) icon!: string;
  }
  